import { useCallback, useEffect, useState } from 'react';
import roleService from '../services/roleService';
import { AVAILABLE_USER_ROLES, setRuntimeUserRoles } from '../config/userRoles';

export default function useUserRoles() {
  const [roles, setRoles] = useState(AVAILABLE_USER_ROLES);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    try {
      const items = await roleService.list();
      setRoles(items);
    } catch {
      setRuntimeUserRoles(AVAILABLE_USER_ROLES);
      setRoles(AVAILABLE_USER_ROLES);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { roles, loading, reload };
}
